import React from 'react';
import axios from "axios";
import {backendEndpoints} from "../../libs/backendEndpoints";
import Button from "react-bootstrap/Button";
import {useConfirm} from "../contexts/ConfirmationModalContext";
import {Group} from "fearless-common";

export default function GroupRestoreButton({ group }: { group: Pick<Group, 'name' | 'id'> }) {
    const { open } = useConfirm();
    return (
        <Button
            variant="outline-success"
            size="sm"
            onClick={() => {
                open(
                    `Are you sure you want to restore ${group?.name}?`,
                    () => axios.put(backendEndpoints.restoreGroup(group.id))
                        .then(() => {
                            window.location.reload();
                        }),
                    false,
                )
            }}
        >
            Restore {group?.name}
        </Button>
    );
}
